<template>
  <div>
    <div v-if="dataSet">
      <div v-if="dataSet.length">
        <div class="d-flex align-center">
          <h3 class="mr-3">Members</h3>
          <div class="counter_">
            <b>{{ dataSet.length }}</b>
          </div>
        </div>
        <v-divider class="my-3"></v-divider>
        <div class="member_chat">
          <div class="mb-2" v-for="(item, n) in dataSet" :key="n">
            <div class="d-flex align-items mb-2">
              <v-avatar dark class="mr-2" size="50">
                <img
                  :src="item.Profile ? item.Profile : ava"
                  alt=""
                  class="obj_fit"
                />
              </v-avatar>
              <b> {{ item.name }} </b>
            </div>
            <v-divider></v-divider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "memberChat",
  computed: {
    ...mapState({
      ava: (state) => state.ava,
    }),
  },
  data() {
    return {
      dataSet: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `chat/member/${this.$route.params.idCourse}`,
      };
      this.$store.dispatch("chat/getData", data).then((data) => {
        this.loading = false;
        this.dataSet = data.data;
      });
    },
  },
};
</script>

<style scoped>
.counter_ {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  width: 24px;
  height: 24px;
  background: #006341;
  border-radius: 50%;
}
.member_chat {
  overflow: hidden;
  overflow-y: auto;
  height: 70vh;
}
/* width */
.member_chat::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.member_chat::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.member_chat::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.member_chat::-webkit-scrollbar-thumb:hover {
  background: #555;
}

</style>
